import { Component, Inject, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { KpiProductHierarchyService } from '../kpiproducthierarchy-master.service';
import { KpiProductHierarchyMappingService } from '../kpiproducthierarchy-mapping.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DatePipe } from '@angular/common';

@Component({
    selector: "kpiproducthierarchy-popup",
    standalone: true,
    imports: [
        MatDialogModule,
        MatTableModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        MatCheckboxModule,
        MatToolbarModule,
        ReactiveFormsModule,
        FormsModule,
        DatePipe
    ],
    templateUrl: './kpiproducthierarchy-popup.component.html',
    styleUrls: ['./kpiproducthierarchy-popup.component.less',],
    encapsulation: ViewEncapsulation.None
})
export class CreateKpiProductHierarchyPopupComponent implements AfterViewInit {

    @ViewChild(MatSort) sort!: MatSort;

    public form: FormGroup;
    isCallSucceed: number = 0;
    isMerged = false;
    historyData: KpiProductHierarchyHistory[] | KpiProductHierarchyMappingHistory[] = [];
    displayedColumns: string[] = ['ChangedAtUtc', 'ChangedBy', 'Field', 'OldValue', 'NewValue'];
    dataSource = new MatTableDataSource<KpiProductHierarchyHistory | KpiProductHierarchyMappingHistory>();
    searchString: string = '';

    constructor(fb: FormBuilder,
        public dialogRef: MatDialogRef<CreateKpiProductHierarchyPopupComponent>,
        private readonly kpiProductHierarchyService: KpiProductHierarchyService,
        private readonly kpiProductHierarchyMappingService: KpiProductHierarchyMappingService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.form = fb.group(
            {
                dimensionName: ['', Validators.required],
                productDescription: ['', Validators.required],
            }, {
        });

        if (this.data.action === 'history') {
            this.loadHistory();
        }
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (data: KpiProductHierarchyHistory | KpiProductHierarchyMappingHistory, filter: string) => {
            const searchStr = filter.toLowerCase();
            return data.ChangedBy?.toLowerCase().includes(searchStr) ||
                   data.Field?.toLowerCase().includes(searchStr) ||
                   data.OldValue?.toLowerCase().includes(searchStr) ||
                   data.NewValue?.toLowerCase().includes(searchStr) ||
                false;
        };
    }

    loadHistory() {
        if (this.data.productMappingSelected) {
            this.kpiProductHierarchyMappingService.getKpiProductHierarchyMappingHistory(this.data.productMappingSelected).subscribe({
                next: (data: KpiProductHierarchyMappingHistory[]) => {
                    this.historyData = data;    
                    this.dataSource.data = data;
                }
            });
        } else if (this.data.productSelected) {
            this.kpiProductHierarchyService.getProductHistory(this.data.productSelected).subscribe({
                next: (data: KpiProductHierarchyHistory[]) => {
                    this.historyData = data;
                    this.dataSource.data = data;
                }
            });
        }
    }

    updateFilteredHistory() {
        this.dataSource.filter = this.searchString.trim();
    }

    onCancel() {
        this.dialogRef.close();
    }
}

